import { taskStates } from 'pages/Tasks/constants'
import type { ResolveActionButtonsProps } from '../../task-details-action-buttons/types'
import { getOfficePendingActionButtons } from './manager-action-buttons/get-manager-pending-state-buttons'
import { getOfficeToDoActionButtons } from './manager-action-buttons/get-manager-todo-state-buttons'

export const getOfficeActionButtons = (props: ResolveActionButtonsProps) => {
  const { task } = props

  const OfficeButtons = {
    [taskStates.todo]: getOfficeToDoActionButtons(props),
    [taskStates.pending]: getOfficePendingActionButtons(props),
    [taskStates.closed]: [],
    default: [],
  }

  return OfficeButtons[task?.statusFe ?? 'default']
}
